import React from "react";

import {
  TableContainer,
  Table,
  TableBody,
  TableHead,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { TextInput } from "../../../../components/base";
import {
  StyledTableRow,
  StyledTableCell,
} from "../../../../components/base/Table";

const useStyles = makeStyles(() => ({
  tableContainer: {
    borderRadius: "9px 0 0 9px",
    border: `1px solid ${COLORS.darks[0][10]}`,
    borderRight: `1px solid ${COLORS.darks[0][50]}`,
    boxShadow: "none",
    boxSizing: "border-box",
  },
  caption: {
    fontWeight: 700,
  },
  row: {
    backgroundColor: COLORS.white,
    "&:last-child": {
      backgroundColor: "rgba(69, 148, 30, 0.5)",
    },
    "&:nth-last-child(3)": {
      backgroundColor: COLORS.darks[0][10],
    },
  },
  lastChildRow: {
    "& p": {
      fontWeight: 700,
    },
  },
  assumptionsHead: {
    padding: 0,
    textAlign: "center",
    backgroundColor: "rgba(233, 151, 45, 0.06)",
  },
  assumptionsHeadTypography: {
    marginTop: -10,
  },
  assumptions: {
    width: 90,
    textAlign: "center",
    padding: 0,
    borderLeft: `1px solid ${COLORS.darks[0][50]}`,
    backgroundColor: "rgba(233, 151, 45, 0.06)",
  },
  assumptionsSuffix: {
    padding: 12,
    borderLeft: `1px solid ${COLORS.darks[0][10]}`,
  },
  groupTitle: {
    "&.child-rows": {
      fontWeight: 300,
      textTransform: "uppercase",
    },
    "&:not(.child-rows)": {
      fontWeight: 700,
    },
    "&.transparent": {
      color: "transparent",
    },
  },
  star: {
    height: 25,
    fontSize: 24,
    color: COLORS.purple,
  },
  purpleBackground: {
    backgroundColor: "rgba(193, 37, 173, 0.06)",
  },
  inputRootStyle: {
    color: COLORS.purple,
    textAlign: "center",
  },
  rootStyle: {
    "& .MuiInput-underline::after": {
      borderBottom: 0,
    },
  },
}));

export const DetailedAnalysisTable = ({ tableData, handleChangeTableData }) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.tableContainer}>
      <Table>
        <TableHead>
          <StyledTableRow>
            <StyledTableCell style={{ color: "transparent" }}>
              Empty
            </StyledTableCell>
            <StyledTableCell className={classes.assumptionsHead}>
              <Typography
                variant="subtitle2"
                className={`${classes.caption} ${classes.assumptionsHeadTypography}`}
              >
                Assumptions<span className={classes.star}>*</span>
              </Typography>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row, i) => (
            <React.Fragment key={i}>
              <StyledTableRow className={classes.row}>
                <StyledTableCell colSpan={!row.assumptions ? 3 : 0}>
                  <Typography
                    className={`
                    ${classes.groupTitle}
                    ${row.childRows ? "child-rows" : ""}
                    ${row.title === "empty" ? "transparent" : ""}
                    `}
                  >
                    {row.title}
                  </Typography>
                </StyledTableCell>
                {row.assumptions ? (
                  <React.Fragment>
                    <StyledTableCell className={classes.assumptions}>
                      <Typography>{row.assumptions}</Typography>
                    </StyledTableCell>
                    <StyledTableCell className={classes.assumptionsSuffix}>
                      <Typography>{row.assumptionsSuffix}</Typography>
                    </StyledTableCell>
                  </React.Fragment>
                ) : null}
              </StyledTableRow>
              {row.childRows
                ? row.childRows.map((childRow, j) => (
                    <StyledTableRow
                      key={j}
                      className={`
                      ${classes.row}
                      ${
                        row.childRows.length - 1 === j
                          ? classes.lastChildRow
                          : ""
                      }
                      ${
                        [tableData.length - 4, tableData.length - 5].includes(i)
                          ? classes.purpleBackground
                          : ""
                      }
                    `}
                    >
                      <StyledTableCell>
                        <Typography>{childRow.childTitle}</Typography>
                      </StyledTableCell>
                      <StyledTableCell className={classes.assumptions}>
                        <TextInput
                          type="number"
                          variant="standard"
                          fullWidth={true}
                          inputRootStyle={classes.inputRootStyle}
                          rootStyle={classes.rootStyle}
                          value={childRow.assumptions}
                          onChange={(value) =>
                            handleChangeTableData(i, j, "assumptions", value)
                          }
                        />
                      </StyledTableCell>
                      <StyledTableCell className={classes.assumptionsSuffix}>
                        <Typography>{childRow.assumptionsSuffix}</Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                : null}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
